"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graph_1 = require("../base/graph");
const edge_1 = require("../base/edge");
const errors_1 = require("../errors");
const directedEdge_1 = require("../base/edges/directedEdge");
const undirectedEdge_1 = require("../base/edges/undirectedEdge");
class MixedGraph extends graph_1.Graph {
    addEdge(edge) {
        if (!(edge instanceof edge_1.Edge)) {
            errors_1.Errors.throwTypeError(edge_1.Edge.name, typeof (edge));
            return false;
        }
        return super.addEdge(edge);
    }
    getEdge(startNode, endNode) {
        for (let edge of this.edges) {
            let start = edge.getStartNode();
            let end = edge.getEndNode();
            if (edge instanceof directedEdge_1.DirectedEdge) {
                if (start == startNode && end == endNode) {
                    return edge;
                }
            }
            else if (edge instanceof undirectedEdge_1.UndirectedEdge) {
                if ((start == startNode && end == endNode)
                    || (start == endNode) && (end == startNode)) {
                    return edge;
                }
            }
        }
        return null;
    }
}
exports.MixedGraph = MixedGraph;
